<template>
  <b-overlay
    :show="show"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <b-card no-body>

      <b-row>

        <b-col
          sm="6"
          class="card-border"
        >
          <b-card-body>
            <!-- <div class="pricing-trial-content d-flex justify-content-between"> -->
            <div class="text-center text-md-left mt-3">
              <h3 class="text-primary">
                {{ $t('crypto-deposit-title') }}
              </h3>
              <p>{{ $t('crypto-deposit-description', { currency: coin }) }}</p>
            </div>

            <!-- images -->
            <b-img
              fluid
              :src="require('@/assets/images/illustration/pricing-Illustration.svg')"
              class="pricing-trial-img"
              alt="svg img"
            />
            <!--/ images -->
          </b-card-body>
        </b-col>
        <!-- </div> -->

        <b-col sm="6">
          <b-card-body>
            <b-alert
              class="p-2"
              show
              variant="danger"
            >
              <p>{{ $t('deposit-warning-dec', { currency: coin }) }}</p>
            </b-alert>
            <b-form class="mt-2">
              <b-row>
                <b-col cols="12">
                  <b-form-group
                    label-for="coin"
                    :label="$t('coin')"
                  >
                    <b-form-input
                      id="coin"
                      v-model="coin"
                      readonly
                      name="coin"
                      :placeholder="$t('coin')"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group
                    label-for="network"
                    :label="$t('Network')"
                  >
                    <b-form-select
                      id="network"
                      v-model="network"
                      text-field="network.nick_name"
                      value-field="network.nick_name"
                      :options="coinInfo.currency_network"
                      :placeholder="$t('Network')"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  v-if="walletAddress"
                  cols="12"
                >
                  <b-form-group
                    id="popover-manual-1"
                    label-for="walletAddress"
                    :label="$t('walletAddress')"
                  >
                    <copy-to-clipboard
                      :text="walletAddress"
                      @copy="copyAddress"
                    >
                      <b-input-group class="mb-2">
                        <b-form-input
                          id="walletAddress"
                          v-model="walletAddress"
                          readonly
                          name="walletAddress"
                          :placeholder="$t('walletAddress')"
                        />
                        <b-input-group-append is-text>
                          <feather-icon
                            icon="CopyIcon"
                            size="20"
                          />
                        </b-input-group-append>
                      </b-input-group>
                    </copy-to-clipboard>
                    <b-popover
                      target="popover-manual-1"
                      :show.sync="pop1"
                      triggers="click"
                      placement="bottom"
                    >
                      {{ $t('copied') }}
                    </b-popover>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
            <div
              class="mt-2 text-center mx-auto d-flex justify-content-center align-center"
            >
              <qrcode-vue
                v-if="walletAddress"
                :value="walletAddress"
                :background="isDarkTheme ? '#283046' : '#fff'"
                :foreground="isDarkTheme ? '#fff' : '#283046'"
                :size="size"
                class="qrcode"
              />
            </div>
          </b-card-body>
        </b-col>
      </b-row>
    </b-card>

    <b-card
      v-if="items.length !== 0"
      class="d-none d-sm-block"
      :title="$t('lastDeposits')"
    >
      <b-row align-h="center">
        <b-col cols="12">
          <b-table
            responsive
            striped
            hover
            sticky-header="1000px"
            :items="items"
            :fields="fields"
          >
            <template #cell(created_at)="data">
              <span>{{
                getFormattedDate(data.item["created_at"])

              }}
              </span>
            </template>
            <template #cell(status)="data">

              <b-button
                :variant="data.item['status'] === 'pending' ? 'warning' : data.item['status'] === 'success' ? 'success' : 'danger'"
                size="sm"
                style="display: block; width: 140px"
              > {{ data.item['status'] }}</b-button>

            </template>

            <template #cell(transaction_id)="data">
              <b-button
                variant="info "
                size="sm"
                style="display: block"
                :disabled="!data.item.transaction_id"
                @click="() => triggerTransactionModal(data.item)"
              >
                {{ $t('transaction_id') }}
              </b-button>
            </template>
          </b-table>
        </b-col>
        <b-col cols="auto">
          <b-pagination
            v-if="totalTransactions > perPageTransactions"
            v-model="currentpageTransactions"
            :total-rows="totalTransactions"
            :per-page="perPageTransactions"
            align="fill"
            size="sm"
            class="mt-2 mb-1"
          />
        </b-col>
      </b-row>
    </b-card>

    <b-card
      v-if="items.length > 0"
      class="d-sm-none"
      :title="$t('lastDeposits')"
    >
      <b-row
        align-h="center"
      >
        <b-col cols="12">
          <div
            v-for="(item, index) in items"
            :key="index"
            :class="$store.state.appConfig.layout.skin === 'dark' ? 'card-bg' : 'transaction-card'"
            class="mb-2"
          >
            <div class="d-flex justify-content-between">
              <div>{{ $t('coin') }}</div>
              <h5>{{ item.currency }}</h5>

            </div>
            <div class="d-flex justify-content-between mt-1">
              <div>{{ $t('Network') }}</div>
              <h5>{{ item.network }}</h5>

            </div>
            <div class="d-flex justify-content-between mt-1">
              <div>{{ $t('amount') }}</div>
              <h5>{{ item.amount }}</h5>

            </div>
            <div class="d-flex justify-content-between mt-1">
              <div>{{ $t('date') }}</div>
              <h5>{{ getFormattedDate(item.date) }}</h5>

            </div>
            <div class="d-flex justify-content-between mt-1">
              <div>{{ $t('status') }}</div>
              <b-button
                :variant="item.status === 'pending' ? 'warning' : item.status === 'success' ? 'success' : 'danger'"
                size="sm"
                style="display: block; width: 140px"
              > {{ item.status }}</b-button>

            </div>
            <div class="d-flex justify-content-between mt-2">
              <b-button
                variant="info"
                size="sm"
                style="width:100%"
                :disabled="!item.transaction_id"
                @click="() => triggerTransactionModal(item)"
              >
                {{ $t('transaction_id') }}
              </b-button>
            </div>
          </div>
        </b-col>
        <b-col cols="auto">
          <b-pagination
            v-if="totalTransactions > perPageTransactions"
            v-model="currentpageTransactions"
            :total-rows="totalTransactions"
            :per-page="perPageTransactions"
            align="fill"
            size="sm"
            class="mb-1"
          />
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      v-model="transactionIdModal"
      centered
      :title="$t('show_transaction_id')"
      ok-only
      :ok-title="$t('show_in_network')"
      no-close-on-backdrop
      :ok-disabled="!selectedTransactionNetwork"
      @ok="openTransaction"
    >
      <b-form-group
        id="popover-manual-2"
        label-for="transaction_id"
        :label="$t('transaction_id')"
      >
        <copy-to-clipboard
          :text="selectedTransactionId"
          @copy="copyTransaction"
        >
          <b-input-group class="mb-2">
            <b-form-input
              id="transaction_id"
              v-model="selectedTransactionId"
              readonly
              name="transaction_id"
              :placeholder="$t('transaction_id')"
            />
            <b-input-group-append is-text>
              <feather-icon
                icon="CopyIcon"
                size="20"
              />
            </b-input-group-append>
          </b-input-group>
        </copy-to-clipboard>
        <b-popover
          target="popover-manual-2"
          :show.sync="pop2"
          triggers="click"
          placement="bottom"
        >
          {{ $t('copied') }}
        </b-popover>
      </b-form-group>
    </b-modal>
  </b-overlay>
</template>
<script>
import cryptoDepositMixin from '@/modules/crypto/views/logic/customer-wallets/cryptoDeposit'

export default {
  mixins: [cryptoDepositMixin],
}
</script>
<style lang="scss">
.card-border {
  border-right: 1px solid #e3e1e9;
}

.transaction-card {
  background-color: #efefef;
  padding: 15px;
  border-radius: 5px;
}

.card-bg {
  background-color: #172238;
  padding: 15px;
  border-radius: 5px;
}

.nameOfTheClass {
  padding: 20px !important;
}
</style>
<style scoped>
::v-deep .qrcode{
  width: 150px;
  height: 150px;
}
::v-deep .qrcode canvas{
  width: 100% !important;
}
</style>
